import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback } from "react";
import { Form } from "react-bootstrap";
import Select from "react-select";
import get from "lodash/get";
import { useFormikContext } from "formik";
import { invPaymentRowInit } from "utils/HelperInvoicePayment";
import CurrencyInput from "react-currency-input-field";
import { useInvoiceInitContext } from "contexts/invoicePage/InvoiceInitContext";
import { useInvoicePaymentModalFormContext } from "contexts/invoicePage/InvoicePaymentModalFormContext";
import { nanoid } from "@reduxjs/toolkit";
export default function InvoicePaymentRow() {
    var _form_factNewInvPaymentRow;
    var values = useFormikContext().values;
    var _useInvoicePaymentModalFormContext = useInvoicePaymentModalFormContext(), form = _useInvoicePaymentModalFormContext.form, formHandlerState = _useInvoicePaymentModalFormContext.formHandlerState, errors = _useInvoicePaymentModalFormContext.errors;
    var setFieldForm = formHandlerState.setFieldForm, addArrayItem = formHandlerState.addArrayItem, removeArrayItem = formHandlerState.removeArrayItem;
    var options = useInvoiceInitContext().options;
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            form === null || form === void 0 ? void 0 : (_form_factNewInvPaymentRow = form.factNewInvPaymentRow) === null || _form_factNewInvPaymentRow === void 0 ? void 0 : _form_factNewInvPaymentRow.map(function(item, index) {
                var paymentInvTypePath = "factNewInvPaymentRow[".concat(index, "].dim_branch_payment_channel_id");
                var isPaymentInvTypeInvalid = !get(form, paymentInvTypePath) && !!get(errors, paymentInvTypePath);
                return /*#__PURE__*/ _jsx("div", {
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ _jsx("fieldset", {
                                className: "col-8",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "row ",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "col-1 flex items-center",
                                            children: index + 1
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "col",
                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                className: "mb-2 form-st-3 pb-1",
                                                children: [
                                                    /*#__PURE__*/ _jsxs(Form.Label, {
                                                        className: "mb-1",
                                                        children: [
                                                            "จ่ายเงินโดย",
                                                            /*#__PURE__*/ _jsx("span", {
                                                                className: "tc-16",
                                                                children: "*"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx(Select, {
                                                        as: "select",
                                                        name: "factNewInvPaymentRow[".concat(index, "].dim_branch_payment_channel_id"),
                                                        placeholder: "เลือกการจ่าย",
                                                        onChange: function(e) {
                                                            setFieldForm("factNewInvPaymentRow[".concat(index, "].dim_branch_payment_channel_id"), e.value);
                                                        },
                                                        className: "w-100 select-st-1 ".concat(isPaymentInvTypeInvalid ? "is-invalid" : ""),
                                                        options: options.branchPaymentChannel.filter(function(d) {
                                                            return d.dim_branch_id == values.dim_branch_id;
                                                        }),
                                                        value: options.branchPaymentChannel.filter(function(d) {
                                                            return d.value == item.dim_branch_payment_channel_id;
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "col",
                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                className: "mb-2 form-st-3 pb-1",
                                                children: [
                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                        className: "mb-1",
                                                        children: "จำนวนเงินที่ชำระ"
                                                    }),
                                                    /*#__PURE__*/ _jsx(CurrencyInput, {
                                                        id: "inv-payment-row-price-".concat(index),
                                                        name: "factNewInvPaymentRow[".concat(index, "].price"),
                                                        value: item.price || 0,
                                                        decimalsLimit: 2,
                                                        decimalScale: 2,
                                                        allowNegativeValue: false,
                                                        onValueChange: function(value, name) {
                                                            setFieldForm("factNewInvPaymentRow[".concat(index, "].price"), value || 0);
                                                        },
                                                        className: "form-control text-end"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "col",
                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                className: "mb-2 form-st-3 pb-1",
                                                children: [
                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                        className: "mb-1",
                                                        children: "หมายเหตุ"
                                                    }),
                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                        type: "text",
                                                        name: "factNewInvPaymentRow[".concat(index, "].remark"),
                                                        className: "form-control",
                                                        placeholder: "กรอกหมายเหตุ",
                                                        value: item.remark,
                                                        onChange: function(e) {
                                                            return setFieldForm("factNewInvPaymentRow[".concat(index, "].remark"), e.currentTarget.value);
                                                        },
                                                        isInvalid: !!get(errors, "factNewInvPaymentRow[".concat(index, "].remark"))
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: " col-auto align-self-center",
                                children: /*#__PURE__*/ _jsx("button", {
                                    type: "button",
                                    className: "btn btn-delete-st-n1",
                                    onClick: function() {
                                        return removeArrayItem("factNewInvPaymentRow", index);
                                    }
                                })
                            })
                        ]
                    })
                }, "inv-payment-row-".concat(index));
            }),
            /*#__PURE__*/ _jsx("button", {
                className: "btn-st-3 btn mt-2",
                type: "button",
                onClick: function() {
                    addArrayItem("factNewInvPaymentRow", _object_spread_props(_object_spread({}, invPaymentRowInit), {
                        id: nanoid()
                    }));
                },
                children: "+ เพิ่มช่องทางชำระเงิน"
            })
        ]
    });
}
